import * as z from 'zod'

// 密码验证
const passwordSchema = z
  .string()
  .min(8, { message: 'retrieve_023' })
  .max(20, { message: 'retrieve_023' })
  .refine((value) => /\D/.test(value), { message: 'retrieve_023' })
// 手机号验证
// const phoneSchema = z
//   .string()
//   .min(1, { message: 'safety_items_030' })
//   .refine((value) => /^\d+-?\d*$/.test(value), { message: 'register_067' })
const phoneSchema = z
  .string()
  .refine((value) => {
    const [, phoneNumber] = value.split('-')
    if (!phoneNumber) return false
    return phoneNumber.length > 0
  }, 'safety_items_030')
  .refine((value) => {
    const [, phoneNumber] = value.split('-')
    return /^\d+$/.test(phoneNumber)
  }, 'register_067')
// 邮箱验证
const emailSchema = z.string().min(1, { message: 'safety_items_033' }).email({ message: 'register_066' })
// 用户协议
const agreementSchema = z.boolean().refine((checked) => checked, {
  message: 'safety_items_036',
})

/**
 * 单独验证规则
 */
export const emailOnlySchema = z.object({ email: emailSchema })
export const phoneOnlySchema = z.object({ phone: phoneSchema })
/**
 * 组合验证规则
 */
// 登录手机架构
export const loginPhoneSchema = z.object({
  phone: phoneSchema,
  password: passwordSchema,
})
// 登录邮箱架构
export const loginEmailSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
})

/**
 * 注册表单验证
 */
export const registerPhoneSchema = z.object({
  phone: phoneSchema,
  password: passwordSchema,
  checked: agreementSchema,
  inviteCode: z.string(),
})

export type TRegisterPhoneSchema = z.infer<typeof registerPhoneSchema>

export const registerEmailSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  checked: agreementSchema,
  inviteCode: z.string(),
})

// 验证码emial / phone
export const validCodeEmailSchema = z.object({
  validCode: z.string().min(1, { message: 'register_032' }),
  phone: z.string(),
})

export const validCodePhoneScheme = z.object({
  validCode: z.string().min(1, { message: 'register_032' }),
})

export const validCodeLoginScheme = z.object({
  validCode: z.string().regex(/^\d{6}$/, 'register_032'),
})

export type TRegisterEmailSchema = z.infer<typeof registerEmailSchema>

export type TTabType = 'phone' | 'email'
export type TVerifyType = TTabType | 'google'
export const geetestSceneId = '18001001' //极验
export const verifyTypeMapResponseCode = {
  20718: 'email',
  20717: 'phone',
  20716: 'google',
}
